import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import suitcss from '../../../helpers/suitcss';
import * as money from '../../../helpers/money';
import { getAppEntityName } from '../../../helpers/entity';
import FormSection from '../form/FormSection';
import FormHeader from '../form/FormHeader';
import Copy from '../../basics/text/TextCopy';
import connectSiteProvider from '../../basics/service/ServiceSiteConnector';

const componentName = 'ActivationFormTariff';
const ActivationFormTariff = props => {
  const {
    formValues,
    fieldMap,
    siteProvider,
  } = props;
  const ui = siteProvider.getGlobalUi();
  const { tariff, creditBalance } = formValues[fieldMap.simStatusResponse.name];
  return (
    <FormSection className={suitcss({ componentName })} asGrid>
      <FormHeader headline={ui.guiWordTariff} />
      <Copy element="div" embedded>
        <p className="u-elementCheckmarkBefore">{getAppEntityName(tariff)}</p>
        {creditBalance &&
          <p className="u-elementCheckmarkBefore">
            {`${ui.guiWordInitialBalance} ${money.toFullCurrency({ unit: creditBalance.unit, currency: 'EUR' })}`}
          </p>
        }
      </Copy>
    </FormSection>
  );
};

ActivationFormTariff.propTypes = {
  siteProvider: PropTypes.object.isRequired,
  fieldMap: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
};

export default compose(
  connectSiteProvider(),
)(ActivationFormTariff);
